/**
 * Robbed shameslessly from here
 * http://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-money-in-javascript
 */

export default {
    methods: {
        currencyFormat(value, symbol = '£', precision = 2) {
            if (!value) {
                return `${symbol}0.00`;
            }
            let n = value,
                c = precision,
                d = '.',
                t = ',',
                s = n < 0 ? '-' : '',
                i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                j = (j = i.length) > 3 ? j % 3 : 0;

            return symbol + (s + (j ? i.substr(0, j) + t : '') +
                i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${t}`) +
                (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '')).toString();
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/currencyFormat.js